import { render, staticRenderFns } from "./PfExhibit.vue?vue&type=template&id=352c4ca7&"
import script from "./PfExhibit.vue?vue&type=script&lang=js&"
export * from "./PfExhibit.vue?vue&type=script&lang=js&"
import style0 from "./PfExhibit.vue?vue&type=style&index=0&id=352c4ca7&prod&lang=scss&"
import style1 from "./PfExhibit.vue?vue&type=style&index=1&id=352c4ca7&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports